import { call, put, takeLatest } from "redux-saga/effects";
import {
  SG_GET_QUESTION_BANKS,
  GET_QUESTION_BANKS,
  SG_FETCH_QUESTION_BANK,
  FETCH_QUESTION_BANK,
  SG_ADD_QUESTION_BANK,
  ADD_QUESTION_BANK,
  SG_UPDATE_QUESTION_BANK,
  UPDATE_QUESTION_BANK,
  SG_DELETE_QUESTION_BANK,
  DELETE_QUESTION_BANK,
  QUESTION_BANKS_PENDING,
  ALL_ERRORS,
} from "constants/actions";
import * as api from "constants/api";

function* getQuestionBanks(action) {
  try {
    yield put({ type: QUESTION_BANKS_PENDING });
    const response = yield call(api.GET_QUESTION_BANKS, action.payload);
    yield put({ type: GET_QUESTION_BANKS, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* fetchQuestionBank(action) {
  try {
    yield put({ type: QUESTION_BANKS_PENDING });
    const response = yield call(api.FETCH_QUESTION_BANK, action.payload);
    yield put({ type: FETCH_QUESTION_BANK, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* addQuestionBank(action) {
  try {
    yield put({ type: QUESTION_BANKS_PENDING });
    const response = yield call(api.ADD_QUESTION_BANK, action.payload);
    yield put({ type: ADD_QUESTION_BANK, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* updateQuestionBank(action) {
  try {
    yield put({ type: QUESTION_BANKS_PENDING });
    const response = yield call(api.UPDATE_QUESTION_BANK, action.payload);
    yield put({ type: UPDATE_QUESTION_BANK, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* deleteQuestionBank(action) {
  try {
    yield put({ type: QUESTION_BANKS_PENDING });
    yield call(api.DELETE_QUESTION_BANK, action.payload);
    yield put({ type: DELETE_QUESTION_BANK, payload: action.payload });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export default function* questionBanksSaga() {
  yield takeLatest(SG_GET_QUESTION_BANKS, getQuestionBanks);
  yield takeLatest(SG_FETCH_QUESTION_BANK, fetchQuestionBank);
  yield takeLatest(SG_ADD_QUESTION_BANK, addQuestionBank);
  yield takeLatest(SG_UPDATE_QUESTION_BANK, updateQuestionBank);
  yield takeLatest(SG_DELETE_QUESTION_BANK, deleteQuestionBank);
}